export default __webpack_public_path__ + "static/media/torocoDevil.73888925.png";